import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { mapDataToUndefinedIfSkip } from 'modules/api/utils';
import { GuardButton } from 'modules/auth/components/GuardButton';
import { useConnection } from 'modules/auth/hooks/useConnection';
import successImage from 'modules/common/assets/stake-success.png';
import { ClaimTable } from 'modules/delegateStaking/components/ClaimTable';
import { useTranslation } from 'modules/i18n';
import { useGetLSPendingUnstakesQuery } from 'modules/liquidStaking/actions/getPendingUnstakes';
import { useLiquidStakingPool } from 'modules/liquidStaking/hooks/useLiquidStakingPool';

import { translation } from './translation';
import { useStyles } from './useStyles';

export function Withdrawal(): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);

  const { isConnected, connectionKey, cacheTime } = useConnection();
  const { poolAddress } = useLiquidStakingPool();

  const { data: poolUnstakes } = useGetLSPendingUnstakesQuery(
    { connectionKey, poolAddress },
    {
      skip: !isConnected,
      selectFromResult: mapDataToUndefinedIfSkip,
      refetchOnMountOrArgChange: cacheTime,
    },
  );

  if (poolUnstakes?.length) {
    return (
      <ClaimTable
        isHidePoolName
        isLSClaim
        pendingUnstakes={poolUnstakes}
        rowClassName={classes.rowClassName}
      />
    );
  }

  return (
    <div className={classes.empty}>
      <div className={classes.content}>
        <img alt="" className={classes.image} src={successImage} />

        <Typography component="div" textAlign="center" variant="h5">
          {t(keys.empty)}
        </Typography>
      </div>

      <GuardButton isConnectedOnly size="large" variant="outlined" />
    </div>
  );
}
